<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @taskAudit="taskAuditFun"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.materialsName"
              placeholder="请输入物料名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.type"
              placeholder="请选择需求类型"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.executeMethod"
              placeholder="请选择需求执行方式"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in executeMethodOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.status"
              placeholder="请选择申请状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.materialsStatus"
              placeholder="请选择物料状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in materialsStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @view="viewFun(arguments)"
        @audit="auditFun(arguments)"
        @revoke="revokeFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 审核确认 -->
    <audit-dialog
      :data-id="id"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogAuditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
    />
    <!-- 待办列表 -->
    <task-audit-dialog
      :dialog-visible.sync="dialogTaskVisible"
      :dialog-title="dialogTitle"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 审核确认
import auditDialog from './components/auditDialog'
// 待办任务
import taskAuditDialog from './components/taskAuditDialog'
// 查看
import viewDialog from '@/views/materielModule/demand/components/viewDialog'
// 数据请求
import { loadMaterialsDemandListDataApi, loadMaterialsDemandExportDataApi, countTodoMaterialsDemandApi, revokeMaterialsDemandApi } from '@/api/materialsDemandDetail'

export default {
  name: 'MaterialsDemandAudit',
  components: {
    CustomTable,
    TableOperation,
    taskAuditDialog,
    auditDialog,
    viewDialog,
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'materials_demand_detail_audit', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['demand_audit'],
            prop: 'audit',
            label: '审核',
            method: 'audit'
          },
          {
            permissionSigns: ['demand_revoke'],
            prop: 'revoke',
            label: '撤销',
            method: 'revoke'
          },
          {
            permissionSigns: ['demand_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['demand_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            materialsName: '',
            type: '',
            executeMethod: '',
            materialsStatus: '',
            status: '',
            isAuditPage: 'true'
          }
        },
        notPaging: true
      },
      // 待办
      todoList: [
        {
          permissionSigns: ['demand_audit'],
          label: '待审核确认物料需求申请',
          method: 'taskAudit',
          count: 0
        }
      ],
      typeOptions: [{ value: 1, label: '方案需求' }, { value: 2, label: '方案外需求' }],
      executeMethodOptions: [{ value: 1, label: '新制作/购买' }, { value: 2, label: '现有库存满足' }, { value: 3, label: '外部租赁' }, { value: 4, label: '自有物资满足' }],
      statusOptions: [{ value: 3, label: '提交' }, { value: 4, label: '审核' }],
      materialsStatusOptions: [{ value: 0, label: '-' }, { value: 11, label: '未制作' }, { value: 12, label: '制作中' }, { value: 13, label: '已发货' }, { value: 21, label: '未调出' }, { value: 22, label: '已调出' }, { value: 31, label: '未租赁' }, { value: 32, label: '已租赁' }, { value: 41, label: '已满足' }, { value: 51, label: '已收货' }],
      yesOrNoOptions: [{ value: 1, label: '是' }, { value: 0, label: '否' }],
      auditResultOptions: [{ value: 1, label: '新制作/购买' }, { value: 2, label: '调拨' }, { value: 3, label: '外部租赁' }, { value: 4, label: '不执行(不结算)' }, { value: 5, label: '退回' }],
      id: null, // 选中的单据ID
      eventType: '',
      // 弹框组件标题名称
      dialogTitle: '',
      // 审核确认弹框组件
      dialogAuditVisible: false,
      // 查看弹框组件
      dialogViewVisible: false,
      // 审核待办清单弹框组件
      dialogTaskVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      // { prop: 'typeValue', label: '需求类型', filterColumn: 'type', filterValue: 'type', filterArray: this.typeOptions, width: 105 },
      { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 90 },
      { prop: 'cityName', label: '市场', filterColumn: 'city_name', width: 90 },
      { prop: 'demandSide', label: '需求方', filterColumn: 'demand_side', width: 120 },
      { prop: 'schemeContent', label: '需求来源', filterColumn: 'scheme_content', width: 200 },
      { prop: 'isExecuteValue', label: '是否执行需求', filterColumn: 'is_execute', filterValue: 'isExecute', filterArray: [{ label: '执行', value: 1 }, { label: '不执行(不结算)', value: 2 }], width: 125 },
      { prop: 'executeMethodValue', label: '需求执行方式', filterColumn: 'execute_method', filterValue: 'executeMethod', filterArray: this.executeMethodOptions, width: 130 },
      { prop: 'materialsName', label: '申请物料名称', filterColumn: 'materials_name', width: 150 },
      { prop: 'applyMakeNumberValue', label: '申请制作数量', filterColumn: '(case is_execute when 2 then \'-\' else apply_make_number end)', width: 125 },
      { prop: 'receiveDepotName', label: '收货库房', filterColumn: 'receive_depot_name', width: 120 },
      { prop: 'receiver', label: '收货人', filterColumn: 'receiver', width: 90 },
      { prop: 'leaseMaterials', label: '租赁内容', filterColumn: 'lease_materials', width: 150 },
      { prop: 'leaseNumber', label: '租赁数量', filterColumn: 'lease_number', width: 105 },
      { prop: 'leaseDirections', label: '租赁备注说明', filterColumn: 'lease_directions', width: 150 },
      { prop: 'auditResultValue', label: '审核结果', filterColumn: 'audit_result', filterValue: 'auditResult', filterArray: this.auditResultOptions, width: 110 },
      { prop: 'auditMakeNumberValue', label: '审核新制作数量', filterColumn: '(case when (is_execute = 2 or audit_result = 4) then \'-\' else audit_make_number end)', width: 140 },
      { prop: 'auditSpareStockMeetsNumberValue', label: '审核备用库存满足数量', filterColumn: '(case when (is_execute = 2 or audit_result = 4) then \'-\' else audit_spare_stock_meets_number end)', width: 180 },
      { prop: 'auditAllocateNumberValue', label: '审核调拨满足数量', filterColumn: '(case when (is_execute = 2 or audit_result = 4) then \'-\' else audit_allocate_number end)', width: 150 },
      { prop: 'auditAllocateDepotName', label: '调出库房', filterColumn: 'audit_allocate_depot_name', width: 120 },
      { prop: 'confirmSupplierValue', label: '确认供应方', filterColumn: 'confirm_supplier', filterValue: 'confirmSupplier', filterArray: [{ label: '未确认', value: 0 }, { label: '总部制作', value: 1 }, { label: '当地制作', value: 2 }], width: 115 },
      { prop: 'remark', label: '备注', width: 150 },
      { prop: 'auditOpinion', label: '审核意见', filterColumn: 'audit_opinion', width: 150 },
      { prop: 'supplierName', label: '供应商名称', filterColumn: 'supplier_name', width: 150 },
      { prop: 'materialsStatusValue', label: '物料状态', filterColumn: 'materials_status', filterValue: 'materialsStatus', filterArray: this.materialsStatusOptions, width: 120 },
      { prop: 'allocateProcessValue', label: '调拨进度', filterColumn: 'allocate_process', filterValue: 'allocateProcess', filterArray: [{ label: '未调拨', value: 1 }, { label: '已调出', value: 2 }, { label: '已调入', value: 3 }, { label: '其他', value: 4 }], width: 105 },
      { prop: 'estimatedCompleteDateValue', label: '预计制作完成时间', filterColumn: 'estimated_complete_date', width: 150 },
      { prop: 'shipmentDateValue', label: '发货时间', filterColumn: 'shipment_date', width: 120 },
      { prop: 'transferMethodValue', label: '运输方式', filterColumn: 'transfer_method', filterValue: 'transferMethod', filterArray: [{ label: '自提', value: 1 }, { label: '快递', value: 2 }, { label: '物流', value: 3 }, { label: '其他', value: 4 }], width: 120 },
      { prop: 'arrivalDateValue', label: '实际到货时间', filterColumn: 'arrival_date', width: 130 },
      { prop: 'statusValue', label: '申请状态', filterColumn: 'status', filterValue: 'status', filterArray: this.statusOptions, width: 110 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'scheme_no', width: 200 },
      { prop: 'viewMaterialsName', label: '需求物料名称', filterColumn: '(case when materials_name = \'\' then demand_materials_name else materials_name end)', width: 150 },
      { prop: 'viewMaterialsNumber', label: '需求物料数量', filterColumn: '(case when apply_make_number = 0 then demand_materials_number else apply_make_number end)', width: 125, isBetween: true },
      { prop: 'applySpareStockMeetsNumberValue', label: '备用库存满足数量', filterColumn: '(case is_execute when 2 then \'-\' else apply_spare_stock_meets_number end)', width: 150 },
      { prop: 'creatorName', filterColumn: 'creator_name', label: '创建人', width: 100 },
      { prop: 'createTimeValue', filterColumn: 'create_time', label: '创建时间', width: 150, isBetween: true },
      { prop: 'submitterName', filterColumn: 'submitter_name', label: '提交人', width: 100 },
      { prop: 'submitTimeValue', filterColumn: 'submit_time', label: '提交时间', width: 150, isBetween: true },
      { prop: 'auditorName', filterColumn: 'auditor_name', label: '审核人', width: 100 },
      { prop: 'auditTimeValue', filterColumn: 'audit_time', label: '审核时间', width: 150, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = false
      loadMaterialsDemandListDataApi({ condition: JSON.stringify(this.masterList.tableQuery) }).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data || []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount () {
      // 待审核确认物料需求申请数量
      countTodoMaterialsDemandApi({ status: '3' }).then(res => {
        this.todoList[0].count = res.data || 0
      })
    },
    // 审核确认待办
    taskAuditFun () {
      this.dialogTitle = '待审核确认物料需求申请'
      this.dialogTaskVisible = !this.dialogTaskVisible
    },
    // 审核确认
    auditFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要审核确认的物料需求申请', type: 'warning' })
        return
      } else if (args[0].status !== 3) {
        this.$message({ message: '物料需求申请不是提交状态，不能审核确认', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.dialogTitle = '审核确认物料需求申请'
      this.dialogAuditVisible = !this.dialogAuditVisible
    },
    // 撤销
    revokeFun (args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要撤销审核的物料需求申请', type: 'warning' })
        return
      } else if (args[0].status !== 4) {
        _this.$message({ message: '物料需求申请不是已审核状态，不能撤销审核结果', type: 'warning' })
        return
      } else if (args[0].materialsStatus !== 11 && args[0].auditResult === 1) {
        _this.$message({ message: '已存在物料委托制作单，请作废委托制作单后再撤销', type: 'warning' })
        return
      } else if (args[0].materialsStatus !== 21 && args[0].auditResult === 2) {
        _this.$message({ message: '已存在物料调拨出库单，请作废物料调拨出库单后再撤销', type: 'warning' })
        return
      } else if (args[0].materialsStatus !== 31 && args[0].auditResult === 3) {
        _this.$message({ message: '已存在物料租赁单，请作废物料租赁单后再撤销', type: 'warning' })
        return
      }

      _this.$confirm('是否确定撤销该物料需求申请审核结果？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        revokeMaterialsDemandApi({ id: args[0].id }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要查看的物料需求申请', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.dialogViewVisible = !this.dialogViewVisible
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadMaterialsDemandExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
